import { render, staticRenderFns } from "./PromotionAccommodationsCard.vue?vue&type=template&id=31d094fc&"
import script from "./PromotionAccommodationsCard.vue?vue&type=script&lang=js&"
export * from "./PromotionAccommodationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports